export const getNDaysLater = (days: number) => {
  return +Date.now() + 60 * 60 * 24 * 1000 * days;
};

export const getNDaysEarlier = (days: number) => {
  return Date.now() + 60 * 60 * 24 * 1000 * -days;
};
